export const TRUSTED_PERSONS_OPTIONS = [
  "id",
  "powerOfAttorney",
  "date",
  "fio",
  "endDate",
  "active",
  "shortFio",
  "descriptionContract",
];
